// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Quiz Attempts Page Styles */
.quiz-attempts-table {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .quiz-attempts-table .table {
    margin-bottom: 0;
  }
  
  .quiz-attempts-table .table th {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    padding: 1rem 0.75rem;
    font-size: 0.9rem;
  }
  
  .quiz-attempts-table .table td {
    padding: 1rem 0.75rem;
    vertical-align: middle;
    border-bottom: 1px solid #f8f9fa;
  }
  
  .quiz-info {
    min-width: 200px;
  }
  
  .quiz-date {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }
  
  .quiz-name {
    font-weight: 500;
    color: #333;
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
  }
  
  .student-name {
    font-size: 0.8rem;
    color: #6c757d;
  }
  
  .pagination-container {
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #f8f9fa;
  }
  
  .pagination-info {
    color: #6c757d;
    font-size: 0.9rem;
  }
  
  /* Quiz Detail Page Styles */
  .course-info {
    font-size: 0.95rem;
  }
  
  .quiz-timing {
    font-size: 0.95rem;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 8px;
  }
  
  .quiz-results-table,
  .quiz-overview {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .quiz-results-table .table,
  .quiz-overview .table {
    margin-bottom: 0;
  }
  
  .quiz-results-table .table th,
  .quiz-overview .table th {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    padding: 0.75rem;
    font-size: 0.85rem;
    text-align: center;
  }
  
  .quiz-results-table .table td,
  .quiz-overview .table td {
    padding: 0.75rem;
    border: 1px solid #dee2e6;
    vertical-align: middle;
    font-size: 0.85rem;
  }
  
  .question-number {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .section-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
  }
  
  /* Badge Styles */
  .badge {
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
  }
  
  .bg-danger {
    background-color: #dc3545 !important;
  }
  
  .bg-success {
    background-color: #28a745 !important;
  }
  
  /* Button Styles */
  .btn-outline-warning {
    border-color: #4fbe6c;
    color: #4fbe6c;
  }
  
  .btn-outline-warning:hover {
    background-color: #4fbe6c;
    border-color: #4fbe6c;
    color: white;
  }
  
  .btn-link.text-warning {
    color: #b8860b !important;
    font-weight: 500;
  }
  
  .btn-link.text-warning:hover {
    color: #9a7209 !important;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .quiz-attempts-table,
    .quiz-results-table,
    .quiz-overview {
      padding: 1rem;
    }
  
    .quiz-attempts-table .table th,
    .quiz-attempts-table .table td,
    .quiz-results-table .table th,
    .quiz-results-table .table td,
    .quiz-overview .table th,
    .quiz-overview .table td {
      padding: 0.5rem 0.25rem;
      font-size: 0.8rem;
    }
  
    .quiz-info {
      min-width: 150px;
    }
  
    .quiz-timing {
      padding: 0.75rem;
    }
  
    .quiz-timing span {
      display: block;
      margin-bottom: 0.5rem;
    }
  
    .quiz-timing span:last-child {
      margin-bottom: 0;
    }
  }
  
  @media (max-width: 576px) {
    .quiz-attempts-table .table,
    .quiz-results-table .table,
    .quiz-overview .table {
      font-size: 0.75rem;
    }
  
    .quiz-date,
    .quiz-name,
    .student-name {
      font-size: 0.75rem;
    }
  
    .badge {
      font-size: 0.65rem;
      padding: 0.3rem 0.5rem;
    }
  
    .btn-sm {
      font-size: 0.7rem;
      padding: 0.25rem 0.5rem;
    }
  }
  
  /* Table Hover Effects */
  .table-hover tbody tr:hover {
    background-color: rgba(184, 134, 11, 0.05);
  }
  
  /* Custom Table Borders */
  .table-bordered {
    border: 1px solid #dee2e6;
  }
  
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6;
  }
  
  /* Table Light Header */
  .table-light {
    background-color: #f8f9fa;
  }
  `, "",{"version":3,"sources":["webpack://./src/quiz.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,wCAAwC;EAC1C;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE;;;MAGE,aAAa;IACf;;IAEA;;;;;;MAME,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;;;MAGE,kBAAkB;IACpB;;IAEA;;;MAGE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,uBAAuB;IACzB;EACF;;EAEA,wBAAwB;EACxB;IACE,0CAA0C;EAC5C;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;IACE,yBAAyB;EAC3B","sourcesContent":["/* Quiz Attempts Page Styles */\n.quiz-attempts-table {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .quiz-attempts-table .table {\n    margin-bottom: 0;\n  }\n  \n  .quiz-attempts-table .table th {\n    background-color: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n    font-weight: 600;\n    color: #495057;\n    padding: 1rem 0.75rem;\n    font-size: 0.9rem;\n  }\n  \n  .quiz-attempts-table .table td {\n    padding: 1rem 0.75rem;\n    vertical-align: middle;\n    border-bottom: 1px solid #f8f9fa;\n  }\n  \n  .quiz-info {\n    min-width: 200px;\n  }\n  \n  .quiz-date {\n    font-size: 0.85rem;\n    color: #6c757d;\n    margin-bottom: 0.25rem;\n  }\n  \n  .quiz-name {\n    font-weight: 500;\n    color: #333;\n    margin-bottom: 0.25rem;\n    display: flex;\n    align-items: center;\n  }\n  \n  .student-name {\n    font-size: 0.8rem;\n    color: #6c757d;\n  }\n  \n  .pagination-container {\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid #f8f9fa;\n  }\n  \n  .pagination-info {\n    color: #6c757d;\n    font-size: 0.9rem;\n  }\n  \n  /* Quiz Detail Page Styles */\n  .course-info {\n    font-size: 0.95rem;\n  }\n  \n  .quiz-timing {\n    font-size: 0.95rem;\n    padding: 1rem;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n  }\n  \n  .quiz-results-table,\n  .quiz-overview {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .quiz-results-table .table,\n  .quiz-overview .table {\n    margin-bottom: 0;\n  }\n  \n  .quiz-results-table .table th,\n  .quiz-overview .table th {\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    font-weight: 600;\n    color: #495057;\n    padding: 0.75rem;\n    font-size: 0.85rem;\n    text-align: center;\n  }\n  \n  .quiz-results-table .table td,\n  .quiz-overview .table td {\n    padding: 0.75rem;\n    border: 1px solid #dee2e6;\n    vertical-align: middle;\n    font-size: 0.85rem;\n  }\n  \n  .question-number {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .section-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #333;\n  }\n  \n  /* Badge Styles */\n  .badge {\n    font-size: 0.75rem;\n    padding: 0.4rem 0.6rem;\n  }\n  \n  .bg-danger {\n    background-color: #dc3545 !important;\n  }\n  \n  .bg-success {\n    background-color: #28a745 !important;\n  }\n  \n  /* Button Styles */\n  .btn-outline-warning {\n    border-color: #4fbe6c;\n    color: #4fbe6c;\n  }\n  \n  .btn-outline-warning:hover {\n    background-color: #4fbe6c;\n    border-color: #4fbe6c;\n    color: white;\n  }\n  \n  .btn-link.text-warning {\n    color: #b8860b !important;\n    font-weight: 500;\n  }\n  \n  .btn-link.text-warning:hover {\n    color: #9a7209 !important;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .quiz-attempts-table,\n    .quiz-results-table,\n    .quiz-overview {\n      padding: 1rem;\n    }\n  \n    .quiz-attempts-table .table th,\n    .quiz-attempts-table .table td,\n    .quiz-results-table .table th,\n    .quiz-results-table .table td,\n    .quiz-overview .table th,\n    .quiz-overview .table td {\n      padding: 0.5rem 0.25rem;\n      font-size: 0.8rem;\n    }\n  \n    .quiz-info {\n      min-width: 150px;\n    }\n  \n    .quiz-timing {\n      padding: 0.75rem;\n    }\n  \n    .quiz-timing span {\n      display: block;\n      margin-bottom: 0.5rem;\n    }\n  \n    .quiz-timing span:last-child {\n      margin-bottom: 0;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .quiz-attempts-table .table,\n    .quiz-results-table .table,\n    .quiz-overview .table {\n      font-size: 0.75rem;\n    }\n  \n    .quiz-date,\n    .quiz-name,\n    .student-name {\n      font-size: 0.75rem;\n    }\n  \n    .badge {\n      font-size: 0.65rem;\n      padding: 0.3rem 0.5rem;\n    }\n  \n    .btn-sm {\n      font-size: 0.7rem;\n      padding: 0.25rem 0.5rem;\n    }\n  }\n  \n  /* Table Hover Effects */\n  .table-hover tbody tr:hover {\n    background-color: rgba(184, 134, 11, 0.05);\n  }\n  \n  /* Custom Table Borders */\n  .table-bordered {\n    border: 1px solid #dee2e6;\n  }\n  \n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6;\n  }\n  \n  /* Table Light Header */\n  .table-light {\n    background-color: #f8f9fa;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
